ACC.amdsvous = {

	_autoload: [
		"buildCarousel",
		"amdsvousblocManager",
		"admsVousCaroussel",
	],

	buildCarousel: function () {
		var owl = $('.amds-vous .owl-carousel'),
				owlOptions = {
					center: true,
					// loop: false,
					margin: 20,
					items: 1,
					dots:true,
					pagination: true,
					responsive: {
						0: {
							items: 1,
							dots: true,
							pagination: true
						}
					}
				};

		if ( $(window).width() < 640 ) {
			owl.owlCarousel(owlOptions);
		} else {
			owl.addClass('off');
		}

		$(window).on('resize', function() {
			if ($(window).width() < 640) {
				if (owl.hasClass('off')) {
					owl.owlCarousel(owlOptions);
					owl.removeClass('off');
				}
			} else {
				if (!owl.hasClass('off')) {
					owl.addClass('off').trigger('destroy.owl.carousel');
				}
			}
		});
	},

	amdsvousblocManager: function(){
		if($('.arcelormittalvous').length){
			$('.arcelormittalvous > .yCmsComponent').each(function(i, el){
				if( i%2 == 0){	
					$(el).find('.amds-vous__row--impair').remove();
					if(i > 0){
						$(el).addClass('pair');	
					}
					
				}else{
					$(el).find('.amds-vous__row--pair').remove();
				}
			});
		} 
	},

	admsVousCaroussel : function(){
		var arcelormittalvous = {items: 1, dots: true};

		if($('.arcelormittalvous').length){
			if ( $(window).width() < 640 ) {
				$('.arcelormittalvous').before($('.arcelormittalvous--title').detach());
				$('.arcelormittalvous').owlCarousel( arcelormittalvous );	
			}

			$(window).on('resize', function() {
				
				if ($(window).width() < 640) {
					$('.arcelormittalvous').before($('.arcelormittalvous--title').detach());
					$('.arcelormittalvous').owlCarousel( arcelormittalvous );	
				}else{
					$('.arcelormittalvous').trigger('destroy.owl.carousel');
				}
			});
		}
		
	}
};
 